import React from 'react';
import {
  AvatarIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  MailIcon,
  LockIcon,
  PhonePortraitIcon,
  IdCardIcon,
  ResetIcon,
  CalendarIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  StopwatchIcon,
  StopwatchWithBallIcon,
  FieldIcon,
  WeatherIcon,
  HumidityIcon,
  TemperatureIcon,
  CloseIcon,
  FootBallIcon,
  FootBallNegativeIcon,
  ClockIcon,
  FirstAidIcon,
  CardIcon,
  CopyIcon,
  StarIcon,
  DoubleArrowIcon,
  DownloadIcon,
  HeightIcon,
  DimensionsIcon,
  HardnessIcon,
  HibrydIcon,
  ProgramIcon,
  HibrydSystemIcon,
  GrassIcon,
  PrecipitationsIcon,
  ActsIcon,
  CountdownIcon,
  RefereeIcon,
  GrassStatusIcon,
  MatchSheetIcon,
  KitSelectorIcon,
  GoalIcon,
  LiveIcon,
  StatsIcon,
  InfoIcon,
  PreviousIcon,
  PlayerMiniShirtIcon,
  MenuIcon,
  FootballEventIcon,
  GoalNetIcon,
  DoubleYellowIcon,
  YellowCardIcon,
  FootballShotIcon,
  RedCardIcon,
  InjurySubstitutionIcon,
  TacticalSubstitutionIcon,
  FileIcon,
  DotsIcon,
  DocumentIcon,
  OwnGoal,
  MissedPenalty,
} from '~/components/Icon/library';

const icons = {
  avatar: <AvatarIcon />,
  chevronDown: <ChevronDownIcon />,
  chevronUp: <ChevronUpIcon />,
  chevronLeft: <ChevronLeftIcon />,
  chevronRight: <ChevronRightIcon />,
  mail: <MailIcon />,
  lock: <LockIcon />,
  phonePortrait: <PhonePortraitIcon />,
  idCard: <IdCardIcon />,
  reset: <ResetIcon />,
  calendar: <CalendarIcon />,
  stopwatch: <StopwatchIcon />,
  stopwatchWithBall: <StopwatchWithBallIcon />,
  field: <FieldIcon />,
  weather: <WeatherIcon />,
  humidity: <HumidityIcon />,
  temperature: <TemperatureIcon />,
  close: <CloseIcon />,
  football: <FootBallIcon />,
  footballNegative: <FootBallNegativeIcon />,
  clock: <ClockIcon />,
  firstAid: <FirstAidIcon />,
  card: <CardIcon />,
  copy: <CopyIcon />,
  star: <StarIcon />,
  doubleArrow: <DoubleArrowIcon />,
  download: <DownloadIcon />,
  height: <HeightIcon />,
  dimensions: <DimensionsIcon />,
  hardness: <HardnessIcon />,
  hibryd: <HibrydIcon />,
  program: <ProgramIcon />,
  hibrydSystem: <HibrydSystemIcon />,
  grass: <GrassIcon />,
  precipitations: <PrecipitationsIcon />,
  acts: <ActsIcon />,
  countdown: <CountdownIcon />,
  referee: <RefereeIcon />,
  grassStatus: <GrassStatusIcon />,
  matchSheet: <MatchSheetIcon />,
  kitSelector: <KitSelectorIcon />,
  goal: <GoalIcon />,
  live: <LiveIcon />,
  stats: <StatsIcon />,
  info: <InfoIcon />,
  previous: <PreviousIcon />,
  miniShirt: <PlayerMiniShirtIcon />,
  menu: <MenuIcon />,
  footballEvent: <FootballEventIcon />,
  goalNet: <GoalNetIcon />,
  doubleYellow: <DoubleYellowIcon />,
  yellowCard: <YellowCardIcon />,
  footballShot: <FootballShotIcon />,
  redCard: <RedCardIcon />,
  injurySubstitution: <InjurySubstitutionIcon />,
  tacticalSubstitution: <TacticalSubstitutionIcon />,
  file: <FileIcon />,
  dots: <DotsIcon />,
  document: <DocumentIcon />,
  ownGoal: <OwnGoal />,
  missedPenalty: <MissedPenalty />,
};

export default icons;
